import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { Paper, Typography } from "@mui/material";
import SignInComponent from "../../components/auth/SignIn";
import { useTranslation } from "react-i18next";

// const Brand = styled(Logo)`
//   fill: ${(props) => props.theme.palette.primary.main};
//   width: 64px;
//   height: 64px;
//   margin-bottom: 32px;
// `;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

// const BigAvatar = styled(Avatar)`
//   width: 92px;
//   height: 92px;
//   text-align: center;
//   margin: 0 auto ${(props) => props.theme.spacing(5)};
// `;

function SignIn() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {/* <Brand /> */}
      <Wrapper>
        <Helmet title={t("sign in")} />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          {t("Welcome")}!
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          {t("Sign in to your account to continue")}
        </Typography>
        <SignInComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
